import { Shield, Users, Key, UserCheck, Building } from "lucide-react";
import { useTranslation } from "../../../i18n";

export default function IdentityCapabilities() {
  const { t } = useTranslation();
  const capabilities = [
    {
      icon: <Key className="h-6 w-6" />,
      title: t('routes.identity.capabilities.items.0.title'),
      description: t('routes.identity.capabilities.items.0.description'),
      benefits: t('routes.identity.capabilities.items.0.benefits'),
      color: "from-emerald-500 to-teal-600",
    },
    {
      icon: <Building className="h-6 w-6" />,
      title: t('routes.identity.capabilities.items.1.title'),
      description: t('routes.identity.capabilities.items.1.description'),
      benefits: t('routes.identity.capabilities.items.1.benefits'),
      color: "from-blue-500 to-indigo-600",
    },
    {
      icon: <Shield className="h-6 w-6" />,
      title: t('routes.identity.capabilities.items.2.title'),
      description: t('routes.identity.capabilities.items.2.description'),
      benefits: t('routes.identity.capabilities.items.2.benefits'),
      color: "from-purple-500 to-pink-600",
    },
    {
      icon: <Users className="h-6 w-6" />,
      title: t('routes.identity.capabilities.items.3.title'),
      description: t('routes.identity.capabilities.items.3.description'),
      benefits: t('routes.identity.capabilities.items.3.benefits'),
      color: "from-green-500 to-emerald-600",
    },
    {
      icon: <Building className="h-6 w-6" />,
      title: t('routes.identity.capabilities.items.4.title'),
      description: t('routes.identity.capabilities.items.4.description'),
      benefits: t('routes.identity.capabilities.items.4.benefits'),
      color: "from-amber-500 to-orange-600",
    },
  ];

  return (
    <section className="pb-20 pt-64 bg-gradient-to-b from-gray-50 to-white -mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('routes.identity.capabilities.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('routes.identity.capabilities.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div
                className={`h-1 w-full bg-gradient-to-r ${capability.color}`}
              ></div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div
                    className={`h-12 w-12 rounded-lg bg-gradient-to-br ${capability.color} flex items-center justify-center mr-4 text-white`}
                  >
                    {capability.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">
                    {capability.title}
                  </h3>
                </div>
                <p className="text-gray-600 mb-4">{capability.description}</p>
                <div className="flex items-center">
                  <span className="text-sm font-medium text-emerald-700 bg-gradient-to-r from-emerald-50 to-teal-50 px-4 py-2 rounded-full border border-emerald-200">
                    {capability.benefits}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
